import {
  Alert,
  Modal,
  Button,
  Upload,
  Statistic,
  Row,
  Col,
  Form,
  Result,
  Card,
  Space,
} from "antd";
import { AiOutlineCloudDownload } from "react-icons/ai";
import { InboxOutlined } from "@ant-design/icons";
import { useState, useContext } from "react";
import { OptionSelect } from "@MASTER";
import { uploadExcel } from "@DELIVERIES";
import { useHistory } from "react-router-dom";
import { exportExcel } from "@HELPERS";
import { AppContext, AuthContext } from "@CONTEXTS";
import PackageResultModal from "../../../deliveries/pre-order/table/package-result-modal";

const { Dragger } = Upload;

const UploadModal = ({ onClose }) => {
  const history = useHistory();
  const [visible, setVisible] = useState(true);
  const [form] = Form.useForm();
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [createdCount, setCreatedCount] = useState(0);
  const [errorList, setErrorList] = useState([]);
  const [error, setError] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [maxFileSizeError, setMaxFileSizeError] = useState(false);
  const { options } = useContext(AppContext);
  const { info } = useContext(AuthContext);
  const [packageResultModal, setPackageResultModal] = useState(false);

  const handleSave = async () => {
    if (maxFileSizeError) {
      return;
    }
    form.validateFields().then(async (values) => {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("file", values.file.file);
        formData.append("warehouse", values.warehouse);
        const result = await uploadExcel(formData);

        if (result?.success) {
          setCreatedCount(result.createdDeliveryCount);
          setErrorList(result.errorList);
          setUploaded(
            info?.autoPackage && result.createdDeliveryCount > 0 ? false : true
          );
          if (info?.autoPackage) {
            const mergeData = result.results.map((item) => {
              return {
                id: item.id,
                barcode: item.barcode,
                customerDeliveryNo: item.customerDeliveryNo,
                totalParcels: item?.totalParcels,
                item: item,
              };
            });
            setPackageResultModal(mergeData);
            if (result.createdDeliveryCount > 0) setVisible(false);
          }
        } else {
          setError(
            "Yükleme sırasında bir sorun oluştu. Lütfen izin verilen dosya şablonuyla tekrar deneyiniz veya destek ekibiyle iletişime geçiniz."
          );
        }
      } catch (e) {
        console.log(e);
        setError(
          "Yükleme sırasında bir sorun oluştu. Lütfen izin verilen dosya şablonuyla tekrar deneyiniz veya destek ekibiyle iletişime geçiniz."
        );
      } finally {
        setLoading(false);
      }

      return false;
    });
  };

  const downloadErrorDeliveries = () => {
    exportExcel(
      "Hatalı Gönderiler",
      [
        { title: "Sipariş Numarası", key: "Sipariş Numarası" },
        { title: "Desi", key: "Desi" },
        { title: "Kaç Parça", key: "Kaç Parça" },
        { title: "Alıcı Adı", key: "Alıcı Adı" },
        { title: "Alıcı Soyadı", key: "Alıcı Soyadı" },
        { title: "Telefon Numarası", key: "Telefon Numarası" },
        { title: "İl", key: "İl" },
        { title: "İlçe", key: "İlçe" },
        { title: "Mahalle", key: "Mahalle" },
        { title: "Açık Adres", key: "Açık Adres" },
        { title: "Hata Sebebi", key: "errorMessage" },
      ],
      errorList
    );
  };

  return (
    <>
      {packageResultModal && (
        <PackageResultModal
          data={packageResultModal}
          onClose={() => {
            setPackageResultModal(false);
          }}
          excel={true}
          preOrderErrorList={errorList}
          excelOnClose={onClose}
        />
      )}
      <Modal
        title="Excel ile Toplu Gönderi Yükle"
        visible={visible}
        onCancel={() => {
          if (!loading) {
            onClose();
          }
        }}
        width={900}
        okText="Gönderileri Yükle"
        cancelText="Pencereyi Kapat"
        onOk={() => handleSave()}
        footer={
          !uploaded && (
            <Space>
              <Button
                disabled={loading}
                onClick={() => {
                  if (!loading) {
                    onClose();
                  }
                }}
              >
                Pencereyi Kapat
              </Button>
              <Button
                type="primary"
                disabled={loading}
                onClick={() => handleSave()}
              >
                Gönderileri Yükle
              </Button>
            </Space>
          )
        }
      >
        {error && <Alert type="error" message={error} closable showIcon />}
        {uploaded && !info.autoPackage ? (
          <>
            {errorList.length > 0 ? (
              <Row gutter={24}>
                {createdCount > 0 && (
                  <Col span={12}>
                    <Card>
                      <Statistic
                        title="Başarıyla Yüklenen Gönderi Sayısı"
                        value={createdCount}
                      />
                      <Button
                        size="small"
                        style={{ marginTop: 16 }}
                        type="primary"
                        onClick={() => history.push("/deliveries/pre-order")}
                      >
                        Paketlenecek Gönderilerim
                      </Button>
                    </Card>
                  </Col>
                )}
                <Col span={createdCount === 0 ? 24 : 12}>
                  <Card>
                    <Statistic
                      title="Hatalı Gönderi Sayısı"
                      value={errorList.length}
                    />
                    <Button
                      size="small"
                      style={{ marginTop: 16 }}
                      type="primary"
                      onClick={() => downloadErrorDeliveries()}
                    >
                      Hatalı Gönderileri İndir
                    </Button>
                  </Card>
                </Col>
              </Row>
            ) : (
              <Result
                status="success"
                title={`${createdCount} gönderi başarıyla oluşturuldu.`}
                subTitle="Gönderileriniz başarıyla oluşturuldu. Paketlenecek Gönderilerim sayfasından barkod yazdırma ve operasyona iletme işlemini yapabilirsiniz."
                extra={[
                  <Button
                    type="primary"
                    key="console"
                    onClick={() => history.push("/deliveries/pre-order")}
                  >
                    Paketlenecek Gönderilerim
                  </Button>,
                  <Button
                    key="buy"
                    onClick={() => {
                      onClose();
                    }}
                  >
                    Kapat
                  </Button>,
                ]}
              />
            )}
          </>
        ) : (
          <>
            <Alert
              type="info"
              showIcon
              message="Excel ile gönderi yükleyebilmek için örnek excel şablonunu doldurmanız gerekmektedir."
              action={
                <Button
                  size="small"
                  type="primary"
                  icon={<AiOutlineCloudDownload />}
                  onClick={() =>
                    options?.DELIVERY_TYPES?.filter(
                      (item) => item.key === "TMH"
                    )?.length > 0 &&
                    options?.DELIVERY_TYPES?.filter(
                      (item) => item.key === "POD"
                    )?.length > 0
                      ? window.open(
                          "/files/Teslimat Tipli Toplu Gönderi Excel.xlsx"
                        )
                      : options?.DELIVERY_TYPES?.filter(
                          (item) => item.key === "TMH"
                        )?.length > 0
                      ? window.open(
                          "/files/Teslimat Tipli Toplu Gönderi Exceli.xlsx"
                        )
                      : options?.DELIVERY_TYPES?.filter(
                          (item) => item.key === "POD"
                        )?.length > 0
                      ? window.open("/files/Toplu Gönderi Exceli.xlsx")
                      : window.open("/files/Toplu Gönderi Excel.xlsx")
                  }
                >
                  Örnek Şablonu İndir
                </Button>
              }
            />
            <Form form={form} layout="vertical" style={{ marginTop: 24 }}>
              <Form.Item
                name="file"
                label="Yüklenecek Dosya:"
                rules={[
                  { required: true, message: "Lütfen bir dosya seçiniz" },
                ]}
              >
                <Dragger
                  name="file"
                  multiple={false}
                  showUploadList={false}
                  action={false}
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  beforeUpload={() => false}
                  onChange={(file) => {
                    setMaxFileSizeError(false);
                    if (file.file.size > 2 * 1024 * 1024) {
                      setMaxFileSizeError(true);
                    } else {
                      setSelectedFile(file.file);
                    }
                  }}
                  fileList={[]}
                >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">
                    {selectedFile
                      ? `${selectedFile.name}`
                      : "Dosya yüklemek için buraya tıklayın veya dosyanızı sürükleyip bu alana bırakın."}
                  </p>
                </Dragger>
              </Form.Item>
              {maxFileSizeError && (
                <Alert
                  type="error"
                  showIcon
                  message="Dosya boyutu izin verilen boyuttan yüksektir (2mb)."
                  style={{ marginBottom: 24 }}
                />
              )}
              <Form.Item
                name="warehouse"
                label="Çıkış Deposu:"
                rules={[
                  {
                    required: true,
                    message:
                      "Lütfen gönderilerin çıkış yapacağı depoyu seçiniz",
                  },
                ]}
              >
                <OptionSelect
                  name="WAREHOUSES"
                  placeholder="Çıkış deposu seçiniz"
                  allowClear={false}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.children?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  showSearch
                />
              </Form.Item>
            </Form>
          </>
        )}
      </Modal>
    </>
  );
};

export default UploadModal;
